/* We Live On Jewelry — global theme behavior.
   Ported from the approved HTML_PREVIEW source. The per-page IIFEs for the
   desktop nav dropdown, mobile menu, scroll reveal, copyright year, and the
   three near-identical image-slider scripts (about / sec_edit0009 /
   sec_edit0010) are consolidated here into one generic, data-driven version
   that runs on every template. */
(function () {
  'use strict';

  // ── Desktop nav dropdown ──
  // Mouse: the panel opens on hover and a click on the label goes to the group page.
  // Touch: a tap opens / closes the panel (it has its own "View all" link).
  // Keyboard: the panel opens on focus (CSS :focus-within) and Escape closes it.
  var hoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)');
  function closeDropdowns() {
    document.querySelectorAll('.nav-dropdown.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      var b = d.querySelector('button');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  document.querySelectorAll('[data-nav-dropdown]').forEach(function (dropdown) {
    var btn = dropdown.querySelector('button');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var url = dropdown.getAttribute('data-url');
      if (hoverDevice.matches && url) { window.location.href = url; return; }
      var isOpen = dropdown.classList.contains('is-open');
      closeDropdowns();
      if (!isOpen) { dropdown.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    });
    dropdown.addEventListener('mouseenter', function () { btn.setAttribute('aria-expanded', 'true'); });
    dropdown.addEventListener('mouseleave', function () { if (!dropdown.classList.contains('is-open')) btn.setAttribute('aria-expanded', 'false'); });
  });
  document.addEventListener('click', closeDropdowns);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDropdowns();
    var active = document.activeElement;
    if (active && active.closest && active.closest('.nav-dropdown')) active.blur();
  });

  // ── Mobile menu "Categories" accordion ──
  document.querySelectorAll('[data-mobile-dropdown]').forEach(function (dropdown) {
    var btn = dropdown.querySelector('button');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var isOpen = dropdown.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(isOpen));
    });
  });

  // ── Mobile menu toggle — sits right below the header, restores focus to the hamburger on close ──
  (function () {
    var btn = document.getElementById('menu-toggle');
    var menu = document.getElementById('mobile-menu');
    if (!btn || !menu) return;
    var header = btn.closest('.site-header');
    var desktop = window.matchMedia('(min-width: 1101px)');
    function place() {
      if (!header) return;
      menu.style.setProperty('--mobile-menu-top', Math.max(0, Math.round(header.getBoundingClientRect().bottom)) + 'px');
    }
    function setOpen(open, returnFocus) {
      menu.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
      if (open) place();
      else if (returnFocus) btn.focus();
    }
    btn.addEventListener('click', function () { setOpen(!menu.classList.contains('is-open'), true); });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false, true); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) setOpen(false, true);
    });
    window.addEventListener('resize', function () {
      if (desktop.matches) setOpen(false, false); else if (menu.classList.contains('is-open')) place();
    });
    window.addEventListener('scroll', function () { if (menu.classList.contains('is-open')) place(); }, { passive: true });
  })();

  // ── Header search panel — focus moves into the field on open and back to the icon on close ──
  (function () {
    var toggle = document.getElementById('search-toggle');
    var panel = document.getElementById('header-search');
    if (!toggle || !panel) return;
    var input = panel.querySelector('input[type="search"]');
    var closeBtn = document.getElementById('search-close');
    function open() {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      if (input) input.focus();
    }
    function close() {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }
    toggle.addEventListener('click', function () { if (panel.hidden) open(); else close(); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !panel.contains(e.target) && !toggle.contains(e.target)) {
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  })();

  // ── Product page gallery: thumbnails and arrows swap the main image ──
  (function () {
    var gallery = document.querySelector('[data-pdp-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('#pdp-main-image');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!main || thumbs.length < 2) return;
    var current = 0;
    function show(i) {
      current = (i + thumbs.length) % thumbs.length;
      var thumb = thumbs[current];
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = thumb.getAttribute('data-src');
      main.alt = thumb.getAttribute('data-alt') || '';
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === current);
        t.setAttribute('aria-pressed', n === current ? 'true' : 'false');
      });
      if (thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { show(i); }); });
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    // preload the other images so switching feels instant
    thumbs.forEach(function (t) { var im = new Image(); im.src = t.getAttribute('data-src'); });
  })();

  // ── Whole product/collection card is clickable; real links/buttons keep their own behavior ──
  document.querySelectorAll('.product-card, .collection-card').forEach(function (card) {
    var link = card.querySelector('.product-media a, .collection-photo a, h3 a');
    if (!link) return;
    var href = link.getAttribute('href');
    card.classList.add('is-clickable-card');
    card.addEventListener('click', function (e) {
      if (e.target.closest('a, button')) return;
      window.location.href = href;
    });
  });

  // ── Add-to-cart button feedback (demo add-to-cart buttons outside the PDP form) ──
  document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var original = btn.innerHTML;
      btn.disabled = true;
      var countEl = document.querySelector('.cart-count');
      if (countEl) countEl.textContent = String((parseInt(countEl.textContent || '0', 10) || 0) + 1);
      setTimeout(function () { btn.disabled = false; btn.innerHTML = original; }, 1200);
    });
  });

  // ── Scroll reveal ──
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('[data-animate]').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('[data-animate]').forEach(function (el) { el.classList.add('is-visible'); });
  }

  // ── Dynamic copyright year ──
  var yearEl = document.getElementById('copyright-year');
  if (yearEl) yearEl.textContent = String(new Date().getFullYear());

  // ── Generic story/editorial image slider — handles every .story-slider on the page ──
  document.querySelectorAll('.story-slider').forEach(function (slider) {
    var slides = slider.querySelectorAll('.story-slide');
    var dots = slider.querySelectorAll('.story-slider-dot');
    if (!slides.length) return;
    var current = 0;
    var autoplay;

    function goTo(n) {
      slides[current].classList.remove('is-active');
      if (dots[current]) { dots[current].classList.remove('is-active'); dots[current].setAttribute('aria-selected', 'false'); }
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) { dots[current].classList.add('is-active'); dots[current].setAttribute('aria-selected', 'true'); }
    }
    function startAuto() { autoplay = setInterval(function () { goTo(current + 1); }, 5000); }
    function stopAuto() { clearInterval(autoplay); }

    var prevBtn = slider.querySelector('.story-slider-btn.prev');
    var nextBtn = slider.querySelector('.story-slider-btn.next');
    if (prevBtn) prevBtn.addEventListener('click', function () { stopAuto(); goTo(current - 1); startAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stopAuto(); goTo(current + 1); startAuto(); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { stopAuto(); goTo(i); startAuto(); }); });

    slider.addEventListener('mouseenter', stopAuto);
    slider.addEventListener('mouseleave', startAuto);
    startAuto();
  });

  // ── Shop sidebar: mobile open/close + Price filter (category links are real collection pages) ──
  (function () {
    var sidebar = document.getElementById('shop-sidebar');
    if (!sidebar) return;
    var backdrop = document.getElementById('shop-sidebar-backdrop');
    var mobileToggle = document.getElementById('mobile-filter-toggle');
    var closeBtn = document.getElementById('sidebar-close-btn');

    function openSidebar() { sidebar.classList.add('is-open'); if (backdrop) backdrop.classList.add('is-open'); }
    function closeSidebar() { sidebar.classList.remove('is-open'); if (backdrop) backdrop.classList.remove('is-open'); }
    if (mobileToggle) mobileToggle.addEventListener('click', openSidebar);
    if (closeBtn) closeBtn.addEventListener('click', closeSidebar);
    if (backdrop) backdrop.addEventListener('click', closeSidebar);

    var priceSelect = document.getElementById('price-select');
    var cards = document.querySelectorAll('#all-products .product-card');
    var emptyState = document.getElementById('shop-empty-state');

    function applyFilters() {
      var range = priceSelect && priceSelect.value !== 'all' ? priceSelect.value.split('-').map(Number) : null;
      var visibleCount = 0;
      cards.forEach(function (card) {
        var cardPrice = parseFloat(card.getAttribute('data-price')) || 0;
        var match = !range || (cardPrice >= range[0] && cardPrice <= range[1]);
        card.style.display = match ? '' : 'none';
        if (match) visibleCount++;
      });
      if (emptyState) emptyState.hidden = cards.length === 0 || visibleCount !== 0;
    }

    if (priceSelect) priceSelect.addEventListener('change', applyFilters);
  })();

  // ── Email sign-up popup (welcome offer) ──
  (function () {
    var popup = document.getElementById('newsletter-popup');
    if (!popup) return;
    var KEY = 'wlj-newsletter-popup';
    var store = {
      get: function () { try { return JSON.parse(window.localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } },
      set: function (v) { try { window.localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* storage unavailable */ } }
    };
    var days = parseInt(popup.getAttribute('data-days'), 10) || 7;
    var delay = (parseInt(popup.getAttribute('data-delay'), 10) || 0) * 1000;
    var posted = popup.getAttribute('data-posted') === 'true';
    var hasErrors = popup.getAttribute('data-has-errors') === 'true';
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var lastFocus = null;
    var timer = null;

    function focusables() {
      return popup.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea');
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function open() {
      if (!popup.hidden) return;
      lastFocus = document.activeElement;
      popup.hidden = false;
      document.body.classList.add('nlp-open');
      window.requestAnimationFrame(function () { popup.classList.add('is-visible'); });
      var field = popup.querySelector('input[type="email"]') || popup.querySelector('.newsletter-popup-done') || popup.querySelector('.newsletter-popup-close');
      if (field) field.focus();
      document.addEventListener('keydown', onKey);
    }
    function close() {
      if (popup.hidden) return;
      popup.classList.remove('is-visible');
      popup.hidden = true;
      document.body.classList.remove('nlp-open');
      document.removeEventListener('keydown', onKey);
      if (!designMode) store.set({ closedAt: Date.now(), subscribed: posted || store.get().subscribed === true });
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    popup.querySelectorAll('[data-nlp-close]').forEach(function (el) { el.addEventListener('click', close); });

    if (posted) { store.set({ closedAt: Date.now(), subscribed: true }); open(); return; }
    if (hasErrors || designMode) { open(); return; }

    var saved = store.get();
    if (saved.subscribed) return;
    if (saved.closedAt && Date.now() - saved.closedAt < days * 86400000) return;
    timer = window.setTimeout(open, delay);
  })();

  // ── Wishlist (saved in this browser only; no account, no app) ──
  (function () {
    var KEY = 'wlj-wishlist';
    function read() {
      try { var v = JSON.parse(window.localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; } catch (e) { return []; }
    }
    function write(list) {
      try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* storage unavailable: toggles still work for this page view */ }
    }
    function paint(btn, saved) {
      btn.classList.toggle('is-active', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    }
    function paintAll() {
      var list = read();
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        paint(btn, list.indexOf(btn.getAttribute('data-handle')) !== -1);
      });
      var n = list.length;
      document.querySelectorAll('[data-wishlist-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
      document.querySelectorAll('[data-wishlist-link]').forEach(function (el) { el.setAttribute('aria-label', 'Wishlist, ' + n + (n === 1 ? ' item' : ' items')); });
    }

    // Wishlist page: build the cards from the saved product handles
    var grid = document.getElementById('wishlist-grid');
    var emptyBox = document.getElementById('wishlist-empty');
    var loading = document.getElementById('wishlist-loading');
    function showEmpty() {
      if (loading) loading.hidden = true;
      if (emptyBox) emptyBox.hidden = grid ? grid.children.length > 0 : true;
    }
    function money(cents) {
      var cur = grid.getAttribute('data-currency') || 'USD';
      var whole = cents % 100 === 0;
      try {
        return new Intl.NumberFormat(grid.getAttribute('data-locale') || undefined, { style: 'currency', currency: cur, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(cents / 100);
      } catch (e) { return (cents / 100).toFixed(2); }
    }
    function buildCard(p) {
      var card = document.createElement('div');
      card.className = 'product-card';
      var media = document.createElement('div');
      media.className = 'product-media';
      var link = document.createElement('a');
      link.href = p.url;
      link.setAttribute('aria-label', 'View ' + p.title);
      if (p.featured_image) {
        var img = document.createElement('img');
        img.src = p.featured_image + (p.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=600';
        img.alt = p.title;
        img.loading = 'lazy';
        img.width = 600;
        img.height = 600;
        link.appendChild(img);
      }
      media.appendChild(link);
      var star = document.createElement('button');
      star.type = 'button';
      star.className = 'product-wishlist';
      star.setAttribute('data-wishlist-toggle', '');
      star.setAttribute('data-handle', p.handle);
      star.setAttribute('aria-label', 'Remove ' + p.title + ' from wishlist');
      star.setAttribute('aria-pressed', 'true');
      star.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
      media.appendChild(star);
      var body = document.createElement('div');
      body.className = 'product-body';
      var h3 = document.createElement('h3');
      var a = document.createElement('a');
      a.href = p.url;
      a.textContent = p.title;
      h3.appendChild(a);
      var price = document.createElement('div');
      price.className = 'product-price';
      price.textContent = money(p.price);
      body.appendChild(h3);
      body.appendChild(price);
      card.appendChild(media);
      card.appendChild(body);
      return card;
    }
    function renderWishlistPage() {
      var list = read();
      if (!list.length) { showEmpty(); return; }
      var root = grid.getAttribute('data-root') || '/';
      Promise.all(list.map(function (handle) {
        return fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (products) {
        var found = products.filter(Boolean);
        // forget products that no longer exist in the store
        if (found.length !== list.length) write(found.map(function (p) { return p.handle; }));
        found.forEach(function (p) { grid.appendChild(buildCard(p)); });
        paintAll();
        showEmpty();
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-wishlist-toggle]') : null;
      if (!btn) return;
      var handle = btn.getAttribute('data-handle');
      if (!handle) return;
      var list = read();
      var at = list.indexOf(handle);
      if (at === -1) list.push(handle); else list.splice(at, 1);
      write(list);
      if (grid && grid.contains(btn)) {
        // on the wishlist page, un-saving removes the card
        var card = btn.closest('.product-card');
        if (card && at !== -1) card.parentNode.removeChild(card);
        showEmpty();
      }
      paintAll();
    });
    window.addEventListener('storage', function (e) { if (e.key === KEY) paintAll(); });

    paintAll();
    if (grid) renderWishlistPage();
  })();

  // ── Legal modals (Privacy Policy / Terms of Service) ──
  (function () {
    var modal = document.getElementById('legal-modal');
    if (!modal) return;
    var title = modal.querySelector('#legal-modal-title');
    var body = modal.querySelector('.legal-modal-body');
    var content = {
      privacy: {
        title: 'Privacy Policy',
        html: '<p>We respect your privacy. This preview site does not yet collect, store, or share personal data beyond what Shopify itself processes for newsletter and contact form submissions.</p><p>A complete, legally-reviewed Privacy Policy covering data collection, cookies, and your rights will be published here before the store goes live and starts processing real orders.</p>'
      },
      terms: {
        title: 'Terms of Service',
        html: '<p>This is a design preview of We Live On Jewelry on a development theme — no purchases can be made here yet.</p><p>Full Terms of Service, including order, payment, shipping, and return terms, will be finalized and published here before launch.</p>'
      }
    };
    document.querySelectorAll('[data-legal]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var c = content[btn.getAttribute('data-legal')];
        if (!c) return;
        title.textContent = c.title;
        body.innerHTML = c.html;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
      });
    });
    modal.querySelectorAll('[data-legal-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
      }
    });
  })();
})();
